import React from 'react';
import { Avatar, Text } from 'src/@vymo/ui/atoms';
import { Bar, BarChart, ResponsiveContainer, Tooltip } from 'recharts';
import { getIcon } from '../queries';
import styles from '../index.module.scss';

function RenderIconLabel(props: any) {
  const { x, y, width, height, index, rankings } = props;

  const user = rankings[index];
  const avatarSize = 48;

  return (
    <g>
      <foreignObject x={x} y={y - (avatarSize + 60)} width={width} height={100}>
        <div className={styles.rankingChart__barLabel}>
          <div className={styles.rankingChart__barLabel__avatarWrapper}>
            <Avatar
              text={user?.name?.charAt(0) || 'U'}
              background="var(--background-default)"
            />
            <span
              className={styles.rankingChart__barLabel__avatarWrapper__badge}
            >
              {getIcon(user.rank)}
            </span>
          </div>
          <Text>{user.name}</Text>
        </div>
      </foreignObject>

      <foreignObject
        x={x}
        y={y}
        width={width}
        height={height}
        textAnchor="middle"
        dominantBaseline="central"
      >
        <div className={styles.rankingChart__barData}>
          <Text type="h2" classNames={styles.rankingChart__barData__text}>
            {' '}
            {user.points}
          </Text>
          <Text type="sublabel" classNames={styles.rankingChart__barData__text}>
            pts.
          </Text>
        </div>
      </foreignObject>
    </g>
  );
}

function Bar3D(props: any) {
  const { x, y, width, height, index } = props;
  const depth = 15;

  if (index === 2) {
    const topPath = `M${Math.floor(x)},${y} L${Math.floor(x - depth)},${
      y - depth
    } L${x + width - depth},${y - depth} L${x + width},${y} Z`;
    return (
      <g>
        <rect
          x={Math.floor(x)}
          y={y}
          width={width}
          height={height}
          fill="#1D7AFC"
          opacity={0.6}
          stroke="none"
        />
        <path d={topPath} fill="#5A98F0" stroke="none" />
      </g>
    );
  }

  if (index === 0) {
    const topPath = `M${x},${y} L${x + depth},${y - depth} L${
      x + width + depth
    },${y - depth} L${x + width},${y} Z`;
    const sidePath = `M${x + width},${y} L${x + width + depth},${y - depth} L${
      x + width + depth
    },${y + height - depth} L${x + width},${y + height} Z`;
    return (
      <g>
        <rect
          x={x}
          y={y}
          width={width}
          height={height}
          fill="#1D7AFC"
          opacity="0.6"
          stroke="none"
        />
        <path d={topPath} fill="#5A98F0" stroke="none" />
        <path d={sidePath} fill="#1D7AFC" stroke="none" />
      </g>
    );
  }

  const topPathCenter = `M${x},${y} L${x + depth},${y - depth} L${
    x + width - depth
  },${y - depth} L${x + width},${y} Z`;
  return (
    <g>
      <rect
        x={x}
        y={y}
        width={width}
        height={height}
        fill="#05c"
        stroke="none"
      />
      <path d={topPathCenter} fill="#2C80F4" stroke="none" />
    </g>
  );
}

function RankingChart({ rankings = [] }: any) {
  const podiumData = rankings.length
    ? [
        { ...rankings[1], rank: 1 },
        { ...rankings[0], rank: 0 },
        { ...rankings[2], rank: 2 },
      ]
    : [];
  return (
    <div className={styles.rankingChart}>
      <ResponsiveContainer>
        <BarChart
          data={podiumData}
          margin={{ top: 120, right: 30, left: 20, bottom: 5 }}
          barCategoryGap={0}
        >
          <Tooltip />

          <Bar
            dataKey="points"
            fill="#05c"
            shape={<Bar3D />}
            label={<RenderIconLabel rankings={podiumData} />}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export default RankingChart;
